import { Box, Grid, Typography, TextField, Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close'; // Import the X icon
import { fCurrency } from '../../../../utils/formatNumber';
import { dispatch, useSelector } from '../../../../redux/store';
import { addGuestBilling } from '../../../../redux/slices/guestRedux/guestBillingRedux';
import { getGuestFromBard } from '../../../../redux/slices/guestRedux/guestRedux';

export default function ProductSelection({ filteredMenu, cardId }) {
  const [selectedItem, setSelectedItem] = useState(null);
  const [quantity, setQuantity] = useState(1);

  let guestBillingAdded;
  ({ addData: guestBillingAdded } = useSelector((state) => state.GuestBillings));

  const handleCardClick = (item) => {
    if (item?.id !== selectedItem?.id) {
      setSelectedItem(item);
    }
  };

  useEffect(() => {
    setQuantity(1);
  }, [selectedItem]);

  useEffect(() => {
    if (guestBillingAdded?.data) {
      dispatch(getGuestFromBard(cardId));
      setSelectedItem({ id: 0 });
    }
  }, [guestBillingAdded]);

  const handleUpdate = () => {
    dispatch(addGuestBilling({
      item: selectedItem,
      qty: quantity,
      cardId
    }));
  };

  return (
    <>
      {filteredMenu?.map((item, index) => (
        <Grid item xs={6} md={3} key={index}>
          <Box
            onClick={() => handleCardClick(item)}
            sx={{
              p: 2,
              height: 150,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              transition: 'transform 0.2s',
              position: 'relative',
              transformStyle: 'preserve-3d',
              transform: selectedItem?.id === item.id ? 'rotateY(180deg)' : 'rotateY(0deg)',
              '&:hover': {
                cursor: 'pointer',
                boxShadow: 6,
              },
            }}
          >
            {/* Front of the Card */}
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                backfaceVisibility: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="subtitle1" noWrap>
                {item.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {fCurrency(item.price)}
              </Typography>
            </Box>

            {/* Back of the Card */}
            {selectedItem?.id === item.id && (
              <Box
                sx={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  backfaceVisibility: 'hidden',
                  transform: 'rotateY(180deg)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                <Typography variant="subtitle1" noWrap>
                  {item.name}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => setQuantity(quantity - 1)}
                    sx={{ border: '1px solid', borderColor: 'divider' }}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>

                  <TextField
                    type="number"
                    size="small"
                    value={quantity}
                    onChange={(e) => setQuantity(Number(e.target.value))}
                    inputProps={{ min: 1, style: { textAlign: 'center' } }}
                    sx={{
                      width: '80px',
                      '& input': {
                        textAlign: 'center'
                      },
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={() => setQuantity(quantity + 1)}
                    sx={{ border: '1px solid', borderColor: 'divider' }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Buttons */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    mt: 2,
                  }}
                >
                  {/* X Icon Button */}
                  <IconButton
                    size="small"
                    onClick={() => setSelectedItem({ id: 0 })}
                    sx={{
                      border: '1px solid',
                      borderColor: 'divider',
                      backgroundColor: 'background.paper',
                      '&:hover': {
                        backgroundColor: 'action.hover',
                      },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>

                  {/* Add To Invoice Button */}
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleUpdate}
                  >
                    Add To Invoice
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      ))}
    </>
  );
}